import { Component } from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'app-root',
    templateUrl: 'app.component.html'
})

export class AppComponent { 
    disableRightClick(event: MouseEvent) {
        event.preventDefault();
    }
    
    disableCopy(event: ClipboardEvent) {
        event.preventDefault();
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/app.component.ts